<template>
  <div>
    <el-dialog title="订单详情" :visible.sync="visible" width="70%" :close-on-click-moda="false">
      <el-row :gutter="24">
        <el-card>
          <div slot="header">
            <span>总订单</span>
          </div>
          <el-row :gutter="24">
            <el-col :span=24>
              <div style="padding: 0 0 15px 15px;"><span><i class=" el-icon-info"></i> 基本信息</span></div>
            </el-col>
            <el-col :span=24>
              <el-table :data="[info]" style="width: 100%;" border
                        :header-cell-style="{background:'#f5f7fa',color:'#80878f'}"
                        :highlight-current-row="true">
                <el-table-column prop="code" label="订单编号" align="center" class="table-cell-title"/>
                <el-table-column label="订单状态" align="center" prop="statusLabel"/>
                <el-table-column label="下单时间" align="center" prop="createTime"/>
                <el-table-column label="订单总金额" align="center" prop="orderFee"/>
                <el-table-column label="优惠总金额" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.freeFee ? '-￥' + scope.row.freeFee : '无优惠' }}
                  </template>
                </el-table-column>
                <el-table-column label="总运费" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.freeFee ? '-￥' + scope.row.freeFee : '免运费' }}
                  </template>
                </el-table-column>

              </el-table>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span=24>
              <div style="padding: 0 0 15px 15px;"><span><i class=" el-icon-coin"></i>支付记录</span></div>
            </el-col>
            <el-col :span=24>
              <el-table :data="[orderPay]" style="width: 100%;" border
                        :header-cell-style="{background:'#f5f7fa',color:'#80878f'}"
                        :highlight-current-row="true">
                <el-table-column label="支付金额" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.payMoney !== '暂未支付' ? '￥' + scope.row.payMoney : '暂未支付' }}
                  </template>
                </el-table-column>
                <el-table-column label="支付渠道" align="center" prop="payChannelLabel"/>
                <el-table-column label="支付时间" align="center" prop="createTime"/>
              </el-table>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span=24>
              <div style="padding: 0 0 15px 15px;"><span><i class="el-icon-s-home"></i>收货地址</span></div>
            </el-col>
            <el-col :span=24>
              <el-table :data="[address]" style="width: 100%;" border
                        :header-cell-style="{background:'#f5f7fa',color:'#80878f'}"
                        :highlight-current-row="true">
                <el-table-column label="收货人" align="center" prop="name"/>
                <el-table-column label="联系电话" align="center" prop="telephone"/>
                <el-table-column label="详细地址" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.brief + '_' + scope.row.detail }}
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span=24>
              <div style="padding: 0 0 15px 15px;"><span><i class="el-icon-s-home"></i>备注</span></div>
            </el-col>
            <el-col :span=24>
              <div>
                <el-input type="textarea" autosize resize="none" disabled v-model="remark" placeholder="未备注"></el-input>
              </div>
            </el-col>
          </el-row>

        </el-card>
      </el-row>

      <el-row :gutter="24">
        <el-card>
          <div slot="header">
            仓库信息
          </div>
          <div class="text item">
            <el-card v-for="(orderSeller,index) in orderSellers" v-bind:key="index" style="margin-bottom: 10px">
              <div slot="header">
                <span>{{ orderSeller.sellerName }}</span>
              </div>
              <el-row :gutter="24">
                <el-col :span=24>
                  <el-table :data="[orderSeller]" style="width: 100%;" border
                            :header-cell-style="{background:'#f5f7fa',color:'#80878f'}"
                            :highlight-current-row="true">
                    <el-table-column label="仓库订单编号" align="center" prop="code"/>
                    <el-table-column label="仓库订单状态" align="center" prop="statusLabel"/>
                    <el-table-column label="物品重量" align="center" prop="goodsWeight"/>
                    <el-table-column label="成本费用" align="center" prop="goodsCostPrice"/>
                    <el-table-column label="商品费用" align="center" prop="goodsFee"/>
                    <el-table-column label="运费" align="center" prop="freightFee"/>
                    <el-table-column label="订单总费用" align="center" prop="orderFee"/>
                    <el-table-column label="商品数量" align="center" prop="goodsAmount"/>
                  </el-table>
                </el-col>
              </el-row>
              <el-col :span=24>
                <div style="padding: 0 0 15px 15px;"><span><i class=" el-icon-coin"></i>货物详情</span></div>
              </el-col>
              <el-row :gutter="24">
                <el-col>
                  <el-table
                      :data="orderSeller.orderItems"
                      border
                      style="width: 100%">
                    <el-table-column type="index" label="序号" align="center"/>
                    <el-table-column label="图片" align="center">
                    <template slot-scope="scope">
                      <el-image
                          style="height: 45px; width: 45px; border-radius: 75px;border: rgb(241,242,244) solid 1px;"
                          :src="dynamicPath+scope.row.goodsIconPath">
                        <div slot="error" class="image-slot">
                          <el-image title="加载失败"
                                    src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/qunyiguan/c6d05d1e8c33703186ec1f89743f979.png"/>
                        </div>
                      </el-image>
                    </template>
                  </el-table-column>
                    <el-table-column prop="goodsName" label="名称" align="center"/>
                    <el-table-column prop="goodsPriceName" label="规格" align="center"/>
                    <el-table-column prop="itemFee" label="价格" align="center"/>
                    <el-table-column prop="goodsAmount" label="数量" align="center"/>
                  </el-table>
                </el-col>
              </el-row>
              <el-col :span=24>
                <div style="padding: 0 0 15px 15px;"><span><i class=" el-icon-coin"></i>发货信息</span></div>
              </el-col>
              <el-row :gutter="24">
                <el-col :span=24>
                  <el-table :data="[orderSeller]" style="width: 100%;" border
                            :header-cell-style="{background:'#f5f7fa',color:'#80878f'}"
                  >
                    <el-table-column label="物流公司" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.logisticsName || '暂未发货' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="物流编号" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.logisticsCode || '暂未发货' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="发货时间" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.sendTime || '暂未发货' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="发货备注" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.sendRemark || '无' }}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
                <el-col :span=23 style="text-align: right;margin: 10px;">
                  <el-tooltip content="收货" placement="top"
                              effect="light">
                    <el-button type="warning"
                               size="mini"
                               :disabled="!(orderSeller.status==='SENDED')"
                               @click="orderSellerReceive(orderSeller.orderSellerId)"
                               icon="el-icon-receiving" round>
                      收货
                    </el-button>
                  </el-tooltip>
                </el-col>
              </el-row>
            </el-card>


            <!--  <el-row :gutter="24">
                <el-col>
                  <el-table
                      :data="info.orderItems"
                      style="width: 100%">
                    <el-table-column type="index" label="序号"/>
                    <el-table-column prop="goodsName" label="名称" width="180"/>
                    <el-table-column prop="goodsAmount" label="数量" width="180"/>
                    <el-table-column label="图片">
                      <template slot-scope="scope">
                        <el-image style="height: 45px; width: 45px; border-radius: 75px;border: rgb(241,242,244) solid 1px;"
                                  :src="dynamicPath+scope.row.goodsIconPath">
                          <div slot="error" class="image-slot">
                            <el-image title="加载失败"
                                      src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/qunyiguan/c6d05d1e8c33703186ec1f89743f979.png"/>
                          </div>
                        </el-image>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>-->
          </div>
        </el-card>
      </el-row>


      <!-- <el-card style="margin-top: 20px">
         <div slot="header">
           <span>下单备注信息</span>
         </div>
         <div class="text item"></div>
       </el-card>-->
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "order-detail",
  data: function () {
    return {
      visible: false,
      info: {},
      address: {},
      orderSellers: [],
      orderPay: {
        createTime: '暂未支付',
        payChannelLabel: '暂未支付',
        payMoney: '暂未支付',
      },
      remark: '',
      dynamicPath: config.dynamicResourcePath
    };
  },
  created: function () {
  },
  computed: {},
  methods: {
    orderSellerReceive(_orderSellerId) {
      var _this = this;
      _this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$common.my_ajax({
          url: '/orderSeller/saveOrderSellerReceived',
          data: {
            orderSellerId: _orderSellerId,
          },
          success: function (response) {
            _this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
              onClose: function () {
                _this.visible = false
              }
            });
          }
        });
      }).catch((e) => {
        console.log(e);
      });
    },
    open(e) {
      if (e) {
        this.visible = true;
        this.info = e;

        this.$common.my_ajax({
          url: '/order/adminGetDetailByOrderId',
          data: {
            orderId: e.orderId,
          },
          success: (response) => {
            let {address, orderSellers, orderPay,remark} = response.item
            this.remark = remark
            if (address) {
              this.address = address;
            }
            if (orderSellers) {
              this.orderSellers = orderSellers;
            }
            if (orderPay) {
              this.orderPay = orderPay
            }
          }
        })
      } else {
        console.log("订单信息获取失败")
      }
    },
    close() {
      this.visible = false;
    },
  },
  watch: {
    visible: function (val, oldVal) {
      if (val) {
        console.log("open")
      } else {
        Object.assign(this.$data, this.$options.data())
      }
    }
  }
}
</script>

<style>

</style>
